const NODE_TYPE = {
  // blocks
  headline: 'headline',
  paragraph: 'paragraph',
  heading: 'heading',

  blockquote: 'blockquote',

  ul: 'ul',
  ol: 'ol',
  li: 'li',

  codeBlock: 'code-block',
  codeLine: 'code-line',

  image: 'image',
  embed: 'embed',

  // inlines
  link: 'link',

  // XXX: Deprecated, should be treated as 'code' mark
  inlineCode: 'inline-code',
};

NODE_TYPE.default = {
  type: NODE_TYPE.paragraph,
  isVoid: false,
  data: {},
}

const srcReceivableData = {
  src: null,
  isReceiving: true,
  error: null,
}

const defaultDataByType = {
  [NODE_TYPE.heading]: { level: 2 }, // Only h2 for now..
  [NODE_TYPE.image]: srcReceivableData,
  [NODE_TYPE.embed]: Object.assign({},
    srcReceivableData,
    {cache: { smaller: false, html: null }},
  ),
};


const MARK_TYPE = {
  bold: 'bold',
  italic: 'italic',
  underlined: 'underlined',  // NOTE(thx): Take out, not used.
  strikethrough: 'strikethrough',
  code: 'code',
  highlighted: 'highilghted',
  nbsp: 'nbsp',
};


const TYPEAHEAD_ACTION = {
  command: 'command',
};

const RENDER_MODE = {
  RENDER_FOR_EDIT: 'render-for-edit',
  RENDER_FOR_PREVIEW: 'render-for-preview',
};


// XXX: No longer used..?
// These are transient types for differentiating heading
// levels, for rendering purposes ONLY. Also, separating
// dash is used to parse the `level`, so don't mess with
// it unless you know what you are doing!
NODE_TYPE.headingOne = `${NODE_TYPE.heading}-${1}`;
NODE_TYPE.headingTwo = `${NODE_TYPE.heading}-${2}`;


// For Portal root node in RichTextEditor
const HOVER_MENU_ROOT_ID = 'mre-hover-menu-root';
const TOOLBAR_MENU_ROOT_ID = 'mre-toolbar-menu-root';


// XXX: No longer true..? Remove..?
// No mark or inline allowed in these top level blocks.
const cleanTopLevelBlockTypes = [
  NODE_TYPE.headline,
  NODE_TYPE.heading,
  NODE_TYPE.codeBlock,
];

const receivableTypes = [
  NODE_TYPE.image,
  NODE_TYPE.embed,
]

const HEADLINE_CHAR_LIMIT = 140;




export {
  NODE_TYPE,
  MARK_TYPE,
  TYPEAHEAD_ACTION,
  RENDER_MODE,
  HOVER_MENU_ROOT_ID, // XXX: Prob won't use it, delete
  TOOLBAR_MENU_ROOT_ID, // XXX: Prob won't use it, delete
  HEADLINE_CHAR_LIMIT,
  cleanTopLevelBlockTypes,
  receivableTypes,

  defaultDataByType,
}



// WEBPACK FOOTER //
// ./src/shared/constants/slate.js